export default __webpack_public_path__ + "static/media/Asset 4.d8551498.png";